import React, { useContext, useEffect, useState } from 'react';
import LinksMenu from '../../components/LinksMenu/LinksMenu';
import Info from '../../components/Info/Info';
import Styles from './ClubRegistrationLandingPage.module.scss';
import ClubRegistrationDashboardRedirect from '../../components/ClubRegistrationDashboardRedirect/ClubRegistrationDashboardRedirect';
import { clubsContext } from '../../context/clubsContext';
import { LocalizationContext } from '../../context/localizationContext';
import { notificationContext } from '../../context/notificationContext';
import Button from '../../components/ClubRegistrationButton/ClubRegistrationButton';
import RegisterNewClub from '../../components/RegisterNewClub/RegisterNewClub';
import Add from '../../assets/images/icons/add.svg';
import keys from '../../keys.json';
import RegisteredClubs from '../../components/RegisteredClubs/RegisteredClubs';
import NotificationBadge from '../../components/NotificationBadge/NotificationBadge';

const LandingPage = (props) => {
  const [currentClubComponent, setClubComponent] = useState(null);
  const { toggleModal, getClubCount } = props;
  const [headerText, setHeaderText] = useState();
  const clubContext = useContext(clubsContext);
  const { state, dispatch } = clubContext;
  const { userClubs, activeLinkKey, selectedClubs } = state;
  const localization = useContext(LocalizationContext);
  const { localizationState } = localization;
  const { headerLabel } = localizationState.localization;
  const { linkKeys } = keys;
  const { addClub } = linkKeys;
  const { notificationState, notificationDispatch } = useContext(notificationContext);
  const { isOpen } = notificationState;

  const handleRegisterNewClubBtnClick = () => {
    setClubComponent(<RegisterNewClub />);
    setHeaderText(headerLabel?.registerClub);
    dispatch({ type: 'SET_LINK_KEY', key: addClub });
  };

  const scrollToHeader = () => {
    const landingPageHeader = document.getElementById('landingPageHeader');
    landingPageHeader.scrollIntoView({ block: 'center' });
  };

  const getSmallAddClubBtn = () => {
    return (
      <button
        className={Styles.smallAddClubtBtn}
        onClick={handleRegisterNewClubBtnClick}
        type="button"
      >
        <img src={Add} alt="Add New Club" />
      </button>
    );
  };

  useEffect(() => {
    if (activeLinkKey === linkKeys?.addClub) {
      setClubComponent(<RegisterNewClub />);
      setHeaderText(headerLabel?.registerClub);
    } else if (activeLinkKey === linkKeys?.myClubs) {
      setClubComponent(<RegisteredClubs />);
      setHeaderText(headerLabel?.myClubs);
    } else {
      setClubComponent(<RegisterNewClub />);
      setHeaderText(headerLabel?.registerClub);
    }
  }, [activeLinkKey]);

  useEffect(() => {
    if (isOpen) {
      scrollToHeader();
      setTimeout(() => {
        notificationDispatch({
          type: 'SET_NOTIFICATION',
          isOpen: false,
          message: null,
          icon: null,
          addedClubSerial: null,
        });
      }, 5000);
    }
  }, [isOpen]);

  useEffect(() => {
    scrollToHeader();
    const alert = (e) => {
      if (state.selectedClubs.length === 0) {
        return undefined;
      }
      const confirmationMessage = 'It looks like you have been editing something. '
        + 'If you leave before saving, your changes will be lost.';

      (e || window.event).returnValue = confirmationMessage;
      return confirmationMessage;
    };
    window.addEventListener('beforeunload', alert);
    return () => {
      window.removeEventListener('beforeunload', alert);
    };
  }, [selectedClubs]);

  return (
    <div className={Styles.landingPage}>
      <div id="landingPageHeader" className={Styles.header}>
        <div className={Styles.redirectBtn}>
          <ClubRegistrationDashboardRedirect onClick={toggleModal} />
        </div>
        <div className={Styles.centerColHeader}>
          <div className={Styles.clubHeaderText}>
            {headerText}
            {activeLinkKey === 'myclubs' && userClubs?.length ? (
              <span className={Styles.clubCount}>
                {getClubCount(userClubs)}
              </span>
            ) : (
              ''
            )}
          </div>
          {activeLinkKey === 'myclubs' && (
            <>
              <span className={Styles.addNewClubBtn}>
                <Button
                  label={headerLabel?.registerNewClubBtn}
                  onClick={handleRegisterNewClubBtnClick}
                  iconAfter={Add}
                />
              </span>
              <div className={Styles.desktopSmallAddClubBtn}>
                {getSmallAddClubBtn()}
              </div>
            </>
          )}
        </div>
      </div>
      <div className={Styles.content}>
        <div className={Styles.leftCol}>
          <LinksMenu
            setClubComponent={setClubComponent}
            setHeaderText={setHeaderText}
            activeLink
          />
        </div>
        <div className={Styles.centerCol}>
          <div className={Styles.mobileHeader}>
            {headerText}
            {activeLinkKey === 'myclubs' && (
              <div className={Styles.mobileBtn}>{getSmallAddClubBtn()}</div>
            )}
          </div>
          {currentClubComponent}
        </div>
        <div className={Styles.rightCol}>
          <Info />
        </div>
      </div>
      <NotificationBadge />
    </div>
  );
};

export default LandingPage;
